var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLsiconAmountDollarOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 25.0996H21.5833C22.9583 25.0996 24.0833 23.9746 24.0833 22.5996C24.0833 21.2246 22.9583 20.0996 21.5833 20.0996H19.0833C17.7083 20.0996 16.5833 18.9746 16.5833 17.5996C16.5833 16.2246 17.7083 15.0996 19.0833 15.0996H25.3333M20.3333 11.3496V14.2671M20.3333 23.8496V28.8496M36.5833 20.0996C36.5833 24.4094 34.8713 28.5426 31.8238 31.5901C28.7763 34.6376 24.6431 36.3496 20.3333 36.3496C16.0235 36.3496 11.8903 34.6376 8.84283 31.5901C5.79536 28.5426 4.08331 24.4094 4.08331 20.0996C4.08331 15.7898 5.79536 11.6566 8.84283 8.60912C11.8903 5.56166 16.0235 3.84961 20.3333 3.84961C24.6431 3.84961 28.7763 5.56166 31.8238 8.60912C34.8713 11.6566 36.5833 15.7898 36.5833 20.0996Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLsiconAmountDollarOutline);
export default __webpack_public_path__ + "static/media/lsicon_amount-dollar-outline.606b6e9c40c21b17b5b7a3a94438942b.svg";
export { ForwardRef as ReactComponent };